"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSurveyOptionRequestToJSON = exports.UpdateSurveyOptionRequestFromJSONTyped = exports.UpdateSurveyOptionRequestFromJSON = exports.instanceOfUpdateSurveyOptionRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateSurveyOptionRequest interface.
 */
function instanceOfUpdateSurveyOptionRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateSurveyOptionRequest = instanceOfUpdateSurveyOptionRequest;
function UpdateSurveyOptionRequestFromJSON(json) {
    return UpdateSurveyOptionRequestFromJSONTyped(json, false);
}
exports.UpdateSurveyOptionRequestFromJSON = UpdateSurveyOptionRequestFromJSON;
function UpdateSurveyOptionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'optionIndex': !(0, runtime_1.exists)(json, 'option_index') ? undefined : json['option_index'],
        'optionText': !(0, runtime_1.exists)(json, 'option_text') ? undefined : json['option_text'],
        'isExclusive': !(0, runtime_1.exists)(json, 'is_exclusive') ? undefined : json['is_exclusive'],
        'isPositive': !(0, runtime_1.exists)(json, 'is_positive') ? undefined : json['is_positive'],
        'isLast': !(0, runtime_1.exists)(json, 'is_last') ? undefined : json['is_last'],
        'optionKey': !(0, runtime_1.exists)(json, 'option_key') ? undefined : json['option_key'],
        'defaultText': !(0, runtime_1.exists)(json, 'default_text') ? undefined : json['default_text'],
    };
}
exports.UpdateSurveyOptionRequestFromJSONTyped = UpdateSurveyOptionRequestFromJSONTyped;
function UpdateSurveyOptionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'option_index': value.optionIndex,
        'option_text': value.optionText,
        'is_exclusive': value.isExclusive,
        'is_positive': value.isPositive,
        'is_last': value.isLast,
        'option_key': value.optionKey,
        'default_text': value.defaultText,
    };
}
exports.UpdateSurveyOptionRequestToJSON = UpdateSurveyOptionRequestToJSON;
